export default __webpack_public_path__ + "static/media/earbuds.16e1c635.svg";